function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import cx from 'classnames';
import { useDragonKitValue } from '../../context/DragonKitContext';

var LinkTo = function LinkTo(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'a' : _ref$tag,
      className = _ref.className,
      type = _ref.type,
      blank = _ref.blank,
      disabled = _ref.disabled,
      url = _ref.url,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["tag", "className", "type", "blank", "disabled", "url", "children"]);

  var _useDragonKitValue = useDragonKitValue(),
      dragonKit = _useDragonKitValue[0];

  var Tag = type === 'route' ? dragonKit.Link : tag;
  var options = {};

  if (['document', 'route'].indexOf(type.toLowerCase()) >= 0) {
    options.to = url;
  } else {
    options.href = url;
  }

  if (blank) {
    options.target = '_blank';
    options.rel = 'noreferrer';
  }

  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: className || cx(disabled && 'disabled')
  }, options, rest), children);
};

LinkTo.displayName = 'LinkTo';
var LinkToDoc;

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  LinkToDoc = require('./doc').doc(LinkTo);
}

var LinkToWrapper = LinkToDoc || LinkTo;
export { LinkToWrapper as LinkTo };